import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TRulerOption } from '@telespot/shared/viewers/data-access';

@Component({
  selector: 'ts-ruler-selector',
  templateUrl: './ruler-selector.component.html',
  styleUrls: ['./ruler-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RulerSelectorComponent {
  @Input() public readonly rulerIcon: TRulerOption;
  @Input() public readonly rulerSize: number;

  @Output() changeRulerIcon = new EventEmitter<TRulerOption>();
  @Output() changeRulerSize = new EventEmitter<number>();
  /** Clear the ruler back to its initial state (no shape, default size). */
  @Output() resetRuler = new EventEmitter<void>();

  public readonly TRulerOption = TRulerOption;

  /** Selectable ruler shapes (excluding NONE, which is reached via the reset button). */
  public readonly rulerIcons = Object.values(TRulerOption).filter((option) => option !== TRulerOption.NONE);

  /** Remix-icon class shown on each ruler-shape button. */
  public readonly rulerIconClasses: Record<string, string> = {
    [TRulerOption.LINE]: 'ri-subtract-line',
    [TRulerOption.CROSS]: 'ri-add-line',
    [TRulerOption.CIRCLE]: 'ri-checkbox-blank-circle-line',
  };
}
